"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// import { GetItemPropsOptions } from 'downshift';
var React = tslib_1.__importStar(require("react"));
var __1 = require("..");
var getLabel = function (suggestion) {
    if (typeof suggestion === 'object') {
        return suggestion.value.toString();
    }
    return suggestion;
};
var SuggestionItem = function (props) {
    var suggestions = props.suggestions, lastSuggestionItem = props.lastSuggestionItem, inputValue = props.inputValue, getItemProps = props.getItemProps, id = props.id, highlightedIndex = props.highlightedIndex, rest = tslib_1.__rest(props, ["suggestions", "lastSuggestionItem", "inputValue", "getItemProps", "id", "highlightedIndex"]);
    var filteredSuggestions = suggestions
        ? suggestions.filter(function (item) {
            return !inputValue ||
                getLabel(item)
                    .toLowerCase()
                    .includes(inputValue.toLowerCase());
        })
        : [];
    if (lastSuggestionItem) {
        filteredSuggestions.push(lastSuggestionItem);
    }
    var result = filteredSuggestions.map(function (item, index) {
        return (React.createElement("li", tslib_1.__assign({ key: getLabel(item) + "-" + index, id: id && id + "-" + index, "data-testid": id + "-menu-item-" + index }, rest, getItemProps({
            item: item
        })),
            React.createElement(__1.Button, { plain: true, active: highlightedIndex === index, tabIndex: -1, fill: true, hoverIndicator: "background", disabled: typeof item === 'object' ? item.displayOnly : false }, typeof item === 'object' ? (item.label) : (React.createElement(__1.Box, { align: "start", pad: "xsmall" }, getLabel(item))))));
    });
    return React.createElement(React.Fragment, null, result);
};
exports.SuggestionItem = SuggestionItem;
//# sourceMappingURL=SuggestionItem.js.map